import { useState } from 'react'
import getThresholdValueFlu from '../../utils/getThresholdValueFlu'
import getThresholdValue from '../../utils/getThresholdValue'
import colorAxis from './colorAxisLevel'
export default function MapLegend(props) {
    return (
      <>
           <svg viewBox="0 0 480 25" height="25" width="480" align="center" {...props}>
    
    <rect
      x="0"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[5].color}
      stroke={colorAxis.dataClasses[5].borderColor}
      strokeWidth="1px"
    ></rect>
    <text
      x="25"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
      {colorAxis.dataClasses[5].name}
    </text>
    <rect
      x="60"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[4].color}
      stroke={colorAxis.dataClasses[4].borderColor}
      strokeWidth="1px"
    ></rect>
    <text
      x="85"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
       {colorAxis.dataClasses[4].name}
    </text>
    <rect
      x="135"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[3].color}
      stroke={colorAxis.dataClasses[3].borderColor}
      strokeWidth="1px"
    ></rect>
    <text
      x="160"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
       {colorAxis.dataClasses[3].name}
    </text>
    <rect
      x="210"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[2].color}
      stroke={colorAxis.dataClasses[2].borderColor}
      strokeWidth="1px"
    ></rect>
     <text
      x="235"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
       {colorAxis.dataClasses[2].name}
    </text>
    <rect
      x="285"
      y="0"
      width="16"
      height="16"
      fill={colorAxis.dataClasses[1].color}
      stroke={colorAxis.dataClasses[1].borderColor}
      strokeWidth="1px"
    ></rect>

    <text
      x="310"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
       {colorAxis.dataClasses[1].name}
    </text>
    <line x1="370" y1="0" x2="370" y2="18" stroke="#CBCCCD" strokeWidth={2} />
    <rect
      x="380"
      y="0"
      width="16"
      height="16"
      fill="#6D6F70"
      stroke="#6D6F70"
      strokeWidth="1px"
    ></rect>
    
    <text
      x="405"
      y="12"
      style={{
        width: '57px',
        height: '16px',
        fontWeight: 400,
        fontSize: '12.64px',
      }}
    >
      No Data
    </text>
    

  
  </svg>
      </>
    )
  
}